<template>
  <sec-section>
    <sec-section-heading :eyebrow="boundaries.eyebrow" :title="boundaries.title" />
    <!-- Each limit as its own card across the full width, then the closing line. -->
    <ul class="boundaries">
      <li v-for="item in boundaries.items" :key="item" class="boundaries__item" data-reveal>
        <sec-not-icon />
        <p class="m500 boundaries__text">{{ item }}</p>
      </li>
    </ul>
    <p class="m500 sec-body-lg boundaries__closing" data-reveal>{{ boundaries.closing }}</p>
  </sec-section>
</template>

<script setup>
import SecSection from '@/components/security/ui/SecSection.vue';
import SecSectionHeading from '@/components/security/ui/SecSectionHeading.vue';
import SecNotIcon from '@/components/security/ui/SecNotIcon.vue';
import { SERVICES } from '@/content/security/services';

const boundaries = SERVICES.boundaries;
</script>

<style scoped>
.boundaries {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(260px, 100%), 1fr));
  gap: var(--sec-s3);
}

.boundaries__item {
  display: flex;
  flex-direction: column;
  gap: var(--sec-s2);
  padding: 1.75rem 1.5rem;
  background: var(--sec-surface);
  border: 1px solid var(--sec-line);
  border-radius: var(--sec-radius-card);
}

.boundaries__text {
  font-size: 1.0625rem;
  line-height: 1.55;
  color: var(--sec-ink);
}

.boundaries__closing {
  color: var(--sec-ink-2);
}
</style>
